import { Box, Divider, Grid } from "@mui/material";
import CheckboxComponent from "./CheckboxComponent";
import localize from "../../common/localize";

export default function ColumnsSelector({
  columnstoShow,
  columnsProcessed,
  setColumnsProcessed,
}) {
  const handleSectionChange = (columnName) => {
    if (!columnsProcessed || columnsProcessed.length === 0) {
      setColumnsProcessed([columnName]);
      return;
    }

    const index = columnsProcessed.findIndex((x) => x === columnName);
    if (index >= 0) {
      columnsProcessed.splice(index, 1);
      setColumnsProcessed([...columnsProcessed]);
      return;
    }

    setColumnsProcessed([...columnsProcessed, columnName]);
  };

  const isColumnSelected = (columnName) =>
    columnsProcessed?.findIndex((x) => x === columnName) >= 0;

  const handleAllChange = (e) => {
    if (e.target.checked) {
      setColumnsProcessed([...columnstoShow]);
      return;
    }

    setColumnsProcessed([]);
  };

  return (
    <Box className="flex flex-col gap-2" sx={{ width: "450px" }}>
      <Box className="flex gap-2">
        <CheckboxComponent
          onValueChanged={handleAllChange}
          propertyName="All"
          text={
            columnsProcessed && columnsProcessed.length > 0
              ? localize.unselect_all_columns
              : localize.select_all_columns
          }
          value={columnsProcessed && columnsProcessed.length > 0}
        />
      </Box>
      <Divider />
      <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {columnstoShow.map((section) => (
          <Grid item xs={6} key={section}>
            <CheckboxComponent
              onValueChanged={() => handleSectionChange(section)}
              propertyName={section}
              text={section}
              value={isColumnSelected(section)}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
